module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-400.woff?de0869e324680c99efa1250515b4b41c";